<div class="error-page-wrap mat-body">
    <div class="main">
        <div class="error-template">
            <mat-icon class="error-icon" aria-hidden="true">error_outline</mat-icon>
            <h1>{{ title }}</h1>
            <div class="error-details">
                <p>{{ message }}</p>
            </div>
            <div class="error-actions">
                <button type="button" (click)="changeState()" mat-raised-button color="primary">
                    Take Me Home
                </button>
            </div>
        </div>
    </div>
</div>
